@if(!processing() && s11Player) {
    <div class="modal-header border-bottom-0 text-white {{getLineClass(s11Player)}}">
        <div class="d-flex align-items-center">
            <h5 class="mb-0">{{s11Player.getPerson().getName()}}</h5>
            @if(sourceAgainstGame) {
                @let headerStatistics = statisticsGetter.getStatistics(s11Player, sourceAgainstGame.getGameRoundNumber());
                @if(headerStatistics) {
                    <button type="button" class="btn btn-link text-white p-0 ms-2" title="Wedstrijdstatistieken"
                        aria-label="Wedstrijdstatistieken" (click)="openStatisticsInfo(headerStatistics)">
                        <fa-icon [icon]="faCircleInfo"></fa-icon>
                    </button>
                }
            }
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss()"></button>
    </div>
}

<div class="modal-body">
    @if( !processing() ) {
        <div class="row justify-content-center">                    
            <!-- @if(alert){
                <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
            } -->                                            
            @if(s11Player && scorePointsMap){
                @let player = sourceAgainstGame !== undefined ?
                    this.sportExtensions.getPlayer(s11Player, sourceAgainstGame.getStartDateTime()) :
                    this.sportExtensions.getCurrentPlayer(s11Player);
                                
                @if (player && sourceAgainstGame) {
                    <div class="card card-person border-0">
                        <div class="card-body py-1 px-2">    
                            <div class="d-flex flex-column">
        
                                @let statistics = statisticsGetter.getStatistics(s11Player,sourceAgainstGame.getGameRoundNumber());                                        
                                @let tmplPoints = $safeNavigationMigration(statistics?.getPoints(player.getLine(), scorePointsMap, undefined));
                                <app-againstgame-title class="mt-3" [againstGame]="sourceAgainstGame"></app-againstgame-title>

                                @if(statistics) {
                                    <s11-player-statistics
                                        [statistics]="statistics"
                                        [line]="s11Player.getLine()"
                                        [scorePointsMap]="scorePointsMap">
                                        <app-player-basics class="col text-center" [card]="true"
                                            [player]="player" [points]="tmplPoints">
                                        </app-player-basics>
                                    </s11-player-statistics>
                                }
        
                                <!-- <div class="text-center mt-3 mb-2">
                                    <h2 *ngIf="processingGames" class="text-center">
                                        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
                                    </h2>
                                    @if(!processingGames && currentGame && currentGameRound){
                                    <button type="button" class="btn btn-outline-primary"
                                        [routerLink]="['/pool/sourcegame', pool.getId(), currentGameRound.getNumber(), currentGame.getId()]">
                                        
                                    </button>
                                    }
                                </div>
                            -->
                            </div>
                        </div>
                    </div>
                }
            }
        </div>
        <!-- @let tmplSofaScoreLink = sofaScoreLink();
        @if(tmplSofaScoreLink) {
            <div class="text-center mt-3 mb-2">
                <button type="button" class="btn btn-outline-primary"
                    (click)="openExternalLink(tmplSofaScoreLink)">
                    <fa-icon [icon]=facSofaScore></fa-icon>
                    <span class="ms-1 d-none d-sm-inline"> SofaScore</span>
                </button>
            </div>
        } -->
    } @else {
        <h2 class="text-center">
            <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
        </h2>
    }
</div>